import * as React from 'react';
import Modal from '../../components/common/modal';
import OrganizationEditForm from '../../components/form/organization-edit-form';
import { GqlOrganization } from 'core/gql/fragments/organization';

import './organization-edit.scss';
import useChurnZero from 'components/common/useChurnZero';

export interface Props {
  shouldShowModal: boolean;
  setShouldShowModal: (shouldShowModal) => any;
  employeeView?: boolean;
  selectedOrganizationId: number | null;
}

const OrganizationEdit: React.FunctionComponent<Props> = ({
  employeeView,
  selectedOrganizationId,
  shouldShowModal,
  setShouldShowModal,
}) => {
  useChurnZero({ organizationId: selectedOrganizationId });

  return (
    <Modal isOpen={shouldShowModal} onClose={() => setShouldShowModal(false)}>
      <OrganizationEditForm
        onFinish={() => setShouldShowModal(false)}
        employeeView={employeeView}
        isModal={true}
        selectedOrganizationId={+selectedOrganizationId}
      />
    </Modal>
  );
};

export default OrganizationEdit;
